import React, {useEffect, useState} from 'react';

import {logOut} from '../../../utils/useToken';


async function deleteAccount(authFetch) {
    return await authFetch(`${process.env.REACT_APP_API_URL}/user/delete`, {
        method: 'DELETE',
    });
}

export default function DeleteAccount({authFetch}) {

    const [user, setUser] = useState({});


    useEffect(() => {
        const fetchUserProfile = async () => {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/user/profile`);
            const data = await response.json();
            setUser(data);
        };

        fetchUserProfile();
    }, [authFetch]);

    const handleSubmit = async e => {
        e.preventDefault();
        await deleteAccount(authFetch);
        logOut();
        window.location.href = '/';
    };

    return (
        <div className="login-wrapper">
            <h1>Delete Account?</h1>
            <p>username: {user.username}</p>
            <p>Are you sure you want to delete this account? This action is final and cannot be reversed!</p>
            <form onSubmit={handleSubmit}>
                <div>
                    <button type="submit">Really Delete Account!!</button>
                </div>
            </form>
        </div>
    );
}

DeleteAccount.propTypes = {};